import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import api from '../../api/paidit-api';
import checkoutService from '../../services/checkout';
import CreditGuardIframe from './creditguard/CreditguardIframe';

const PaymentSetup = () => {
    const branch = useSelector(state => state.business.branch);
    const summary = useSelector(state => state.order.checkSummary);
    const [paymentConfig, setPaymentConfig] = useState({});

    useEffect(() => {
        api().payment.generateSecurePayment(branch.id, summary).then(data => {
            setPaymentConfig(data);
        });
    }, [branch.id, summary]);

    if (paymentConfig.provider === 'creditguard') {
        return (
            <CreditGuardIframe
                onSubmit={mpiTranId => checkoutService.startCheckout([{ type: 'credit', mpiTranId }])}
                iframeUrl={paymentConfig.iframeUrl}
                mpiTranId={new URL(paymentConfig.iframeUrl).search.split('=')[1]}
            />
        );
    }

    return null;
};

PaymentSetup.propTypes = {

};

export default PaymentSetup;
